<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconTestScriptIcon_16"
    viewBox="0 0 15 14"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M12.7 3.526h-1.417a1.9 1.9 0 0 0 .117-.631C11.4 1.846 10.529 1 9.45 1c-.682 0-1.274.341-1.625.853l-.325.423-.325-.43A1.97 1.97 0 0 0 5.55 1C4.471 1 3.6 1.846 3.6 2.895c0 .22.046.436.117.631H2.3c-.721 0-1.293.562-1.293 1.263L1 11.737c0 .7.579 1.263 1.3 1.263h10.4c.722 0 1.3-.562 1.3-1.263V4.789c0-.7-.578-1.263-1.3-1.263M9.45 2.263c.357 0 .65.284.65.632a.643.643 0 0 1-.65.631.643.643 0 0 1-.65-.631c0-.348.292-.632.65-.632m-3.9 0c.357 0 .65.284.65.632a.643.643 0 0 1-.65.631.643.643 0 0 1-.65-.631c0-.348.292-.632.65-.632m7.15 9.474H2.3v-1.263h10.4zm0-3.158H2.3v-3.79h3.302L4.25 6.577l1.053.739L6.85 5.269l.65-.858.65.858 1.547 2.047 1.053-.74L9.398 4.79H12.7z"
    />
</svg>
